import { HUMAN_SECURITY_API_KEY } from 'constants.js';

export const initializeHumanSecurity = () => {
  const scriptId = 'human-security-script';

  if (!document.getElementById(scriptId)) {
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `//client.px-cloud.net/${HUMAN_SECURITY_API_KEY}/main.min.js`;
    script.async = true;

    document.head.appendChild(script);

    script.onerror = () => {
      console.error('Failed to load the HS script.');
    };
  }
};
